import { render, staticRenderFns } from "./TheComplianceLogger.vue?vue&type=template&id=2717ee22&scoped=true&lang=html"
import script from "./TheComplianceLogger.vue?vue&type=script&lang=ts"
export * from "./TheComplianceLogger.vue?vue&type=script&lang=ts"
import style0 from "./TheComplianceLogger.vue?vue&type=style&index=0&id=2717ee22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717ee22",
  null
  
)

export default component.exports